import { Injectable } from '@angular/core';
import { CommonService } from '../../common/common.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AttachmentService {
  

  constructor(
    public http : HttpClient
  ) { }
  private extractData(res: Response) {
    let body = res;
    return body || {};
  }
  upload(formData: any, payload, attachmentType): Observable<any> {
    let url;
    if (attachmentType === 'REPORT_IMAGE') {
      url = CommonService.BASE_URL + '/api/v1/public/attachments/upload';
    } else if (attachmentType === 'ATTACHMENT_DOCUMENT') {
      url = CommonService.BASE_URL + '/api/v1/public/attachments/uploadDocument';
    } else if (attachmentType === 'OFFICE_DOCUMENT') {
      url = CommonService.BASE_URL + '/api/v1/public/attachments/uploadOfficeFile';
    }

    let query = '?managementCommitteeId=' + payload.managementCommitteeId 
    + '&collageId='+payload.collageId + '&userId='+payload.userId + '&formTypeId='
    +payload.formTypeId + '&formId='+payload.formId + '&caption='+payload.caption + '&fileName='+payload.fileName;

    let finalUrl = url + query;
    let httpOptions = {
      headers: new HttpHeaders({
        'Accept': '*/*',
        // 'Authorization': 'Bearer ' + token
      })
    }
    return this.http.post(finalUrl, formData, httpOptions)
      .pipe(
        map(this.extractData),
        catchError(error => {
          if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
          } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
              `Backend returned code ${error.status}, ` +
              `body was: ${error.error}`);
            if (error.status === 403) {
              window.dispatchEvent(new CustomEvent('user:force-logout'));
            }
          }
          // return an observable with a user-facing error message
          return throwError(
            'Something bad happened; please try again later.');
        })
      );
  }

  delete(payload, attachmentType): Observable<any> {
    let url;
    if (attachmentType === 'REPORT_IMAGE') {
      url = CommonService.BASE_URL + '/api/v1/public/attachments/remove';
    } else if (attachmentType === 'ATTACHMENT_DOCUMENT') {
      url = CommonService.BASE_URL + '/api/v1/public/attachments/removeDocument';
    } else if (attachmentType === 'OFFICE_DOCUMENT') {
      url = CommonService.BASE_URL + '/api/v1/public/attachments/removeOfficeFile';
    }

    let httpOptions = {
      headers: new HttpHeaders({
        'Accept': '*/*',
        // 'Authorization': 'Bearer ' + token
      })
    };
    return this.http.put(url, payload, httpOptions)
      .pipe(
        map(this.extractData),
        catchError(error => {
          if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
          } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
              `Backend returned code ${error.status}, ` +
              `body was: ${error.error}`);
            if (error.status === 403) {
              window.dispatchEvent(new CustomEvent('user:force-logout'));
            }
          }
          // return an observable with a user-facing error message
          return throwError(
            'Something bad happened; please try again later.');
        })
      );
  }

  editCaption(payload): Observable<any> {
    let url = CommonService.BASE_URL + '/api/v1/public/attachments/editCaption';

    let httpOptions = {
      headers: new HttpHeaders({
        'Accept': '*/*',
        // 'Authorization': 'Bearer ' + token
      })
    };
    return this.http.put(url, payload, httpOptions)
      .pipe(
        map(this.extractData),
        catchError(error => {
          if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
          } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
              `Backend returned code ${error.status}, ` +
              `body was: ${error.error}`);
            if (error.status === 403) {
              window.dispatchEvent(new CustomEvent('user:force-logout'));
            }
          }
          // return an observable with a user-facing error message
          return throwError(
            'Something bad happened; please try again later.');
        })
      );
  }

  addWeblinks(token:any,payload:any): Observable<any> {
    let url = CommonService.BASE_URL + '/api/v1/secure/weblinks/add';
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    }
    return this.http.post(url, payload,httpOptions)
      .pipe(
        map(this.extractData),
        catchError(error => {
          if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
          } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
              `Backend returned code ${error.status}, ` +
              `body was: ${error.error}`);
            if (error.status === 403) {
              window.dispatchEvent(new CustomEvent('user:force-logout'));
            }
          }
          // return an observable with a user-facing error message
          return throwError(
            'Something bad happened; please try again later.');
        })
      );
  }

  
}
